import dayjs from 'dayjs';
import _ from 'lodash';

/**
 * Builds the edit link for a report row in the study header buttons. Routes Event rows to the event page, Interim and Notification rows to the study report page with epoch start and stop bounds plus the lower-cased type, and everything else to the study summary report.
 *
 * @param row - Report row carrying its type, ids and start/stop dates.
 * @returns Path to the report editor for that row.
 */
const generateEditReportLink = (row: any) => {
  if (row.type === 'Event') {
    return `/events/${row.eventId}`;
  }
  if (row.type === 'Interim' || row.type === 'Notification') {
    const startDateEpoch = dayjs(row.start).valueOf();
    const endDateEpoch = dayjs(row.stop).valueOf();
    return `/studies/report/${row.studyFid}/${_.lowerFirst(row.type)}/${startDateEpoch}/${endDateEpoch}`;
  }
  return `/studies/report/${row.studyFid}/study`;
};

export { generateEditReportLink };
